import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyBlackCherryIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./BlackCherryIcon-bdcad246.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyBlackCherryIcon as P };
